<script>
  import SalesMirror from "./SalesMirror.svelte";
  import SalesManagementDashboard from "./SalesManagementDashboard/SalesManagementDashboard.svelte";
  import MarketingDashboard from "./MarketingDashboard.svelte";
  import ManagementDashboard from "./ManagementDashboard.svelte";
  import ManagementSixModules from "./ManagementSixModules.svelte";
  import { MDBBtn, MDBContainer, MDBInput, MDBModal, MDBModalBody } from "mdbsvelte/src/index.js";
  import { onMount } from "svelte";
  import ProgressBar from "svelte-progress-bar";
  import Toasts from "./components/Toasts.svelte";

  export let name;

  let develop_mode = false;
  let different_user_view_u_n;

  // gemeinsame Daten:
  let res_partner_all = false;
  let crm_lead_all = false;
  let sale_order_all = false;
  let marketing_team = false;
  let lost_leads = false;
  let lost_opportunities = false;
  let insights = false;
  let marketing_goals = false;
  let goals_all = false;
  let archived = false;
  let messenger_res = false;
  let subscription_all = false;
  let activated_all = false;
  let revenue = false;
  let aco_cost = false;
  let goal_revenue = false;
  let monthly_cost = false;
  let clv_targets = false;
  let helptexts = false;
  let in_show_helptext_id = false;
  let sold_boluses = 0;

  let in_show_marketing_nav_item = false;
  let in_show_management_nav_item = false;
  let show_market_nav_item = false;
  let in_show_market_nav_item = false;
  let in_show_sales_dashboard = false;
  let progress;

  let see_all_in_sales = false;
  let isOpen = true;
  let isLogin = false;
  let var_authenticate = false;
  let var_authenticate_sales = false;
  let var_authenticate_marketing = false;

  let start_get_marketing_data = false;
  let see_only_marketing = false;

  //Wieder entfernen:
  let u_n = "";
  let p_w = "";

  let laender_dict = [
    { long: "Germany", short: "DE", checked: true },
    { long: "Austria", short: "AT", checked: true },
    { long: "Switzerland", short: "CH", checked: true },
    { long: "United Kingdom", short: "UK", checked: true },
    { long: "Ireland", short: "IE", checked: true },
    { long: "United States", short: "US", checked: true },
    { long: "Netherlands", short: "NL", checked: true },
    { long: "Denmark", short: "DK", checked: true },
    { long: "New Zealand", short: "NZ", checked: true },
    { long: "Australia", short: "AU", checked: true },
    // { long: 'France', short: 'FR', checked: true },
    // { long: 'Belgium', short: 'BE', checked: true },
    // { long: 'Luxembourg', short: 'LX', checked: true },
    { long: "ROW", short: "ROW", checked: true },
  ];

  // let laender_dict = false;
  let finished_get_data_sales;
  if (develop_mode) {
    isOpen = false;
  }

  // marketing soll in production mode anfangs true sein!
  let show_sales = true;
  let show_marketing = false;
  let show_boli = false;
  let show_management = false;
  let show_management_six_modules = false;
  let show_sales_management_dashboard = false;
  let show_marketing_nav_item = false;

  //Date Filter:
  let marketing_start_date;
  let marketing_end_date;
  let date_start_string_month;
  let date_end_string_month;
  let date_start_string_year;
  let date_end_string_year;

  let login_failed = false;

  $: {
    finished_get_data_sales;

    if (finished_get_data_sales) {
      show_marketing_nav_item = true;
      start_get_marketing_data = true;
      show_market_nav_item = true;

      progress.complete();
    }

    if (see_only_marketing) {
      selectMarketingDashboard();
    }
  }

  $: {
    login_failed;
    if (login_failed) {
      progress.complete();
    }
  }

  onMount(() => {
    if (develop_mode) {
      var_authenticate = !var_authenticate;

      var_authenticate_sales = true;
    }
  });

  function login() {
    isOpen = false;
    login_failed = false;
    progress.start();
    var_authenticate = !var_authenticate;
    var_authenticate_marketing = true;
  }

  function toggle() {
    isOpen = !isOpen;
  }

  let selected_dashboard = "sales";

  function selectDashboard() {}

  function selectSalesDashboard() {
    show_marketing = false;
    show_boli = false;
    show_management = false;
    show_management_six_modules = false;
    show_sales_management_dashboard = false;
    show_sales = true;
    selected_dashboard = "sales";
  }

  function selectMarketingDashboard() {
    show_sales = false;
    show_boli = false;
    show_management = false;
    show_management_six_modules = false;
    show_sales_management_dashboard = false;
    show_marketing = true;
    selected_dashboard = "marketing";
  }

  function selectManagementDashboard() {
    show_sales = false;
    show_boli = false;
    show_marketing = false;
    show_management_six_modules = false;
    show_sales_management_dashboard = false;
    show_management = true;
    selected_dashboard = "management";
  }

  function selectManagementSixModules() {
    show_sales = false;
    show_boli = false;
    show_marketing = false;
    show_management = false;
    show_management_six_modules = true;
    show_sales_management_dashboard = false;
    selected_dashboard = "management_modules";
  }

  function selectSalesManagementDashboard() {
    show_sales = false;
    show_boli = false;
    show_marketing = false;
    show_management = false;
    show_management_six_modules = false;
    show_sales_management_dashboard = true;
    selected_dashboard = "sales_management";
  }
</script>

<Toasts />

<MDBContainer size={false}>
  <MDBModal backdrop={false} frame={false} fullHeight={false} {isOpen} side={false} {toggle}>
    <MDBModalBody>
      <form>
        <p class="h5 text-center mb-4">Sign in</p>
        <div class="grey-text">
          <MDBInput
            autocomplete={"on"}
            background={false}
            bind:value={u_n}
            containerClass={false}
            error="wrong"
            fab={false}
            far={false}
            fas={false}
            filled={false}
            formGroup={false}
            gap={false}
            group
            hint={false}
            icon="envelope"
            iconSize={false}
            id="email"
            isControlled={false}
            isNotEmpty={false}
            label="Type your email"
            labelClass={false}
            outline={false}
            success="right"
            type="email"
            validate
          />
          <MDBInput
            autocomplete={"on"}
            background={false}
            bind:value={p_w}
            containerClass={false}
            fab={false}
            far={false}
            fas={false}
            filled={false}
            formGroup={false}
            gap={false}
            group
            hint={false}
            icon="lock"
            iconSize={false}
            id="password"
            isControlled={false}
            isNotEmpty={false}
            label="Type your password"
            labelClass={false}
            outline={false}
            type="password"
            validate
          />
        </div>

        {#if u_n == "stefan.buerscher@smaxtec.com" || u_n == "ghaith.rahmooni@smaxtec.com" || u_n == "hardani.maulana@smaxtec.com" || u_n == "simon.fischer@smaxtec.com"}
          <MDBInput
            bind:value={different_user_view_u_n}
            label="Type your email"
            id="email"
            icon="envelope"
            group
            type="email"
            validate
            error="wrong"
            success="right"
            formGroup={false}
            far={false}
            fas={false}
            fab={false}
            hint={false}
            filled={false}
            gap={false}
            iconSize={false}
            outline={false}
            background={false}
            containerClass={false}
            isNotEmpty={false}
            isControlled={false}
            labelClass={false}
            autocomplete={"on"}
          />
        {/if}

        <div class="text-center">
          <MDBBtn gradient={false} on:click={login} rounded={false}>Login</MDBBtn>
        </div>
      </form>
    </MDBModalBody>
  </MDBModal>
</MDBContainer>

<nav class="navbar navbar-expand navbar-light navbar-bg">
  <h1 class="navbar-brand">
    {#if selected_dashboard == "marketing"}
      <strong>Marketing Dashboard</strong>
    {:else if selected_dashboard == "sales"}
      <strong>Sales Mirror</strong>
    {:else if selected_dashboard == "management"}
      <strong>Market Reporting</strong>
    {:else if selected_dashboard == "management_modules"}
      <strong>Management Dashboard</strong>
    {:else if selected_dashboard == "sales_management"}
      <strong>Sales Management Dashboard</strong>
    {/if}
  </h1>
  <ProgressBar bind:this={progress} color={"grey"} width={"100%"} />
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      {#if !see_only_marketing}
        <li class={selected_dashboard == "sales" ? "nav-item active" : "nav-item"}>
          <a class="nav-link" on:click={selectSalesDashboard}>Sales</a>
        </li>
      {/if}
      {#if show_marketing_nav_item && in_show_marketing_nav_item}
        <li class={selected_dashboard == "marketing" ? "nav-item active" : "nav-item"}>
          <a class="nav-link" on:click={selectMarketingDashboard}>Marketing</a>
        </li>
      {/if}
      {#if show_market_nav_item && in_show_market_nav_item}
        <li class={selected_dashboard == "management" ? "nav-item active" : "nav-item"}>
          <a class="nav-link" on:click={selectManagementDashboard}>Market</a>
        </li>
      {/if}
      {#if in_show_management_nav_item}
        <li class={selected_dashboard == "management_modules" ? "nav-item active" : "nav-item"}>
          <a class="nav-link" on:click={selectManagementSixModules}>Management</a>
        </li>
      {/if}
      {#if in_show_sales_dashboard}
        <li class={selected_dashboard == "sales_management" ? "nav-item active" : "nav-item"}>
          <a class="nav-link" on:click={selectSalesManagementDashboard}>Sales Management</a>
        </li>
      {/if}
    </ul>
  </div>

  <div class="navbar-collapse collapse">
    <ul class="navbar-nav navbar-align">
      <li class="nav-item dropdown">
        <a class="nav-icon dropdown-toggle d-inline-block d-sm-none" data-bs-toggle="dropdown" href="#">
          <i class="align-middle" data-feather="settings" />
        </a>
      </li>
    </ul>
  </div>
</nav>

<SalesMirror
  hidden={see_only_marketing}
  bind:aco_cost
  bind:activated_all
  bind:archived
  bind:clv_targets
  bind:crm_lead_all
  bind:finished_get_data={finished_get_data_sales}
  bind:goal_revenue
  bind:goals_all
  bind:helptexts
  bind:in_show_helptext_id
  bind:in_show_management_nav_item
  bind:in_show_market_nav_item
  bind:in_show_marketing_nav_item
  bind:in_show_sales_dashboard
  bind:insights
  bind:laender_dict
  bind:login_failed={isLogin}
  bind:login_isOpen={isOpen}
  bind:lost_leads
  bind:lost_opportunities_all={lost_opportunities}
  bind:marketing_goals
  bind:marketing_team
  bind:messenger_res
  bind:monthly_cost
  bind:res_partner_all
  bind:revenue
  bind:sale_order_all
  bind:see_all_in_sales
  bind:show_main_content={show_sales}
  bind:subscription_all
  bind:u_n
  bind:var_authenticate
  bind:sold_boluses
  {different_user_view_u_n}
  on:switch_dashboard={selectDashboard}
  {p_w}
  bind:see_only_marketing
/>

{#if show_marketing_nav_item && in_show_marketing_nav_item}
  <MarketingDashboard
    {u_n}
    {start_get_marketing_data}
    bind:show_link={show_marketing_nav_item}
    {marketing_team}
    bind:show_main_content={show_marketing}
    {res_partner_all}
    {crm_lead_all}
    {lost_leads}
    {lost_opportunities}
    {sale_order_all}
    {insights}
    {marketing_goals}
    sales_goals={goals_all}
    {archived}
    {goals_all}
    {messenger_res}
    bind:laender_dict
    {subscription_all}
    {activated_all}
    {helptexts}
    {in_show_helptext_id}
    bind:marketing_start_date
    bind:marketing_end_date
    bind:date_start_string_month
    bind:date_end_string_month
    bind:date_start_string_year
    bind:date_end_string_year
  />
{/if}

{#if show_market_nav_item && in_show_market_nav_item}
  <ManagementDashboard
    bind:show_main_content={show_management}
    bind:laender_dict
    {marketing_team}
    {crm_lead_all}
    {lost_leads}
    {lost_opportunities}
    {insights}
    {marketing_goals}
    {messenger_res}
    {archived}
    {res_partner_all}
    {sale_order_all}
    {subscription_all}
    {activated_all}
    {helptexts}
    {in_show_helptext_id}
    bind:marketing_start_date
    bind:marketing_end_date
    bind:date_start_string_month
    bind:date_end_string_month
    bind:date_start_string_year
    bind:date_end_string_year
  />
{/if}

{#if show_management_six_modules && in_show_management_nav_item}
  <ManagementSixModules
    bind:show_main_content={show_management_six_modules}
    bind:laender_dict
    {activated_all}
    {marketing_goals}
    {messenger_res}
    {res_partner_all}
    {subscription_all}
    {lost_leads}
    {crm_lead_all}
    {lost_opportunities}
    {archived}
    {sale_order_all}
    {revenue}
    {aco_cost}
    {goal_revenue}
    {monthly_cost}
    {clv_targets}
    {helptexts}
    {in_show_helptext_id}
  />
{/if}

{#if in_show_sales_dashboard && show_sales_management_dashboard}
  <SalesManagementDashboard
    bind:show_main_content={show_sales_management_dashboard}
    {laender_dict}
    {activated_all}
    {marketing_goals}
    {messenger_res}
    {res_partner_all}
    {subscription_all}
    {lost_leads}
    {crm_lead_all}
    {lost_opportunities}
    {archived}
    {sale_order_all}
    {revenue}
    {aco_cost}
    {goal_revenue}
    {monthly_cost}
    {clv_targets}
    {goals_all}
    {sold_boluses}
  />
{/if}

<style>
  :global(*) {
    box-sizing: border-box;
  }

  form {
    border: 0 none;
    text-align: left;
  }
</style>
